<template>
  <div>
    <div class="black-overlay"></div>

  <div class="modal modal--welcomeback no_space" id="spinning_wheel">

  <div class="modal__content">
    <button class="btn modal-close"><i class="icon-close"></i></button>

    <div class="modal__header">
        <h1>
          {{ getTranslations.home_modals_post_game_spin_wheel_congratulations }}
        </h1>
        <h1>  {{ getTranslations.home_modals_post_game_spin_wheel_spin_the_wheel }}
        </h1>
      </div>
    <div class="modal__body achievement">

      <div class="spinning_wheel">

      <div id="wrapper">

        <div id="wheel">
          <div id="inner-wheel">
            <div class="sec"><span class="fa"><img src="/static/images/bonus_points.svg"></span></div>
            <div class="sec"><span class="fa"><img src="/static/images/bonus_points.svg"></span></div>
            <div class="sec"><span class="fa"><img src="/static/images/bonus_points.svg"></span></div>
            <div class="sec"><span class="fa"><img src="/static/images/bonus_points.svg"></span></div>
            <div class="sec"><span class="fa"><img src="/static/images/bonus_points.svg"></span></div>
            <div class="sec"><span class="fa"><img src="/static/images/bonus_points.svg"></span></div>
          </div>
          <img class="border_wheel" src="/static/images/wheel_border.svg" alt="">
          <div id="spinouter">
            <div  id="inner-spin"><img src="/static/images/wheel_inside.svg" alt=""></div>
          </div>

          <div id="shine"></div>
        </div>

      </div>
<!--      <button class="claim_prize" id="spin_wheel"-->
<!--              @click.prevent="spin()">hiii{{ getTranslations.home_modals_notifications_spin_wheel_spin }}-->
<!--      </button>-->
        <a @click.prevent="spin()" class="btn2 btn2--std btn2--small" style="cursor:pointer">{{ getTranslations.visitor_free_trial_save_score }} {{ getTranslations.home_modals_post_game_spin_wheel_spin }}</a>

      </div>
<!--      <div class="spinning_wheel prize" v-else-if="determineResult() && hasMadeASpin">-->
<!--        <button id="spin_wheel1"-->
<!--                @click.prevent="claimPrize()"-->
<!--                class="claim_prize">{{ getTranslations.home_modals_notifications_spin_wheel_see }}-->
<!--        </button>-->
<!--      </div>-->
<!--      <span v-show="showResult && !determineResult() && hasMadeASpin">-->
<!--       {{ getTranslations.home_modals_notifications_spin_wheel_you_lost }}-->
<!--      </span>-->
    </div>
    </div>
  </div>
    <div class="modal-overlay"></div>
    <component :is="componentModalAnswer" />

  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { spinTheWheel } from '@/common/jQuery';
import PostGamePrize from '@/components/visitor/freeTrial/modals/PostGameFreePlayPrizeWon';


// achievements_modal_wheel
export default {
  name: 'spin-wheel',
  data() {
    return {
      componentModalAnswer: null,
      numOfClicks: 1,
      degree: 1800,
      result: '',
      hasMadeASpin: false,
      clicked: false,
      disableDuration: false,
      normalDurationPassed: false,
      haveRewardResponse: false,
      showResult: false,
      watchModal: false,
    };
  },
  methods: {
    ...mapActions('profile', [
      'sendNotificationReward',
    ]),
    ...mapMutations('game', [
      'storeRegistrationPoints',
    ]),
    ...mapMutations('profile', [
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    closeSpin() {
      this.setRedeemed();
      this.$emit('close');
    },
    claimPrize() {
      this.setRedeemed();
      this.$emit('openNewModal', this.prizeName);
    },
    determineResult() {
    },
    initSpinCounter() {
      setTimeout(this.setDuration, 4000); // do action after 4 seconds passed (minimum spin wheel duration)
    },
    setDuration() {
      this.normalDurationPassed = true;
      if (this.haveRewardResponse) {
        this.showResult = true;
        this.hasMadeASpin = true;
      }
    },
    setDisableDuration() {
      this.disableDuration = true;
    },
    calculateResult() {
      return 3; // 5: try again state
    },
    getRewardId() {
      return parseInt(this.notificationRewardName.substr(this.notificationRewardName.indexOf('.') + 1), 10) + 1;
    },
    setRedeemed() {
      // set activeNotification in vuex as read
      // not necessary for Score projects
      this.setRedeemedNotification(this.checkedNotificationId);
      this.$emit('read', this.checkedNotificationId);
    },
    clearData() {

    },
    spin() {
      spinTheWheel(3, this.degree, this.calculateResult());
      setTimeout(() => {
        this.componentModalAnswer = PostGamePrize;
      }, 6000);
    },
  },
  computed: {
    modalForHome() {
      return this.modalForHomePage;
    },
    ...mapState('common', [
      'modalForHomePage',
    ]),
    ...mapState('profile', [
      'checkedNotificationId',
      'checkedNotificationReadStatus',
      'notificationRewardId',
      'notificationRewardName',
      'notificationPrizeWon',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>


<style scoped>
  .noSpin{
    width:100%;
    height:100%;
    -webkit-transition: all 0s cubic-bezier(0,.99,.44,.99) !important;
    -moz-transition:    all 0s cubic-bezier(0,.99,.44,.99) !important;
    -o-transition:      all 0s cubic-bezier(0,.99,.44,.99) !important;
    -ms-transition:     all 0s cubic-bezier(0,.99,.44,.99) !important;
    transition:         all 0s cubic-bezier(0,.99,.44,.99) !important;
  }
  .spinNormal{
    width:100%;
    height:100%;
    -webkit-transition: all 4s cubic-bezier(0,.99,.44,.99) !important;
    -moz-transition:    all 4s cubic-bezier(0,.99,.44,.99) !important;
    -o-transition:      all 4s cubic-bezier(0,.99,.44,.99) !important;
    -ms-transition:     all 4s cubic-bezier(0,.99,.44,.99) !important;
    transition:         all 4s cubic-bezier(0,.99,.44,.99) !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/visitor/freeTrial/modals/SpinWheel.vue